<ng-container *ngIf="!this.isRefreshAvialable()">


    <div class="layout-wrapper" (click)="onLayoutClick()" [ngClass]="{'layout-wrapper-overlay-sidebar': isOverlay(),
                 'layout-wrapper-slim-sidebar': isSlim(),
                 'layout-wrapper-horizontal-sidebar': isHorizontal(),
                 'layout-wrapper-overlay-sidebar-active': overlayMenuActive,
                 'layout-wrapper-sidebar-inactive': staticMenuDesktopInactive,
                 'layout-wrapper-sidebar-mobile-active': staticMenuMobileActive}">
        <doctor-app-topbar></doctor-app-topbar>

        <!-- <doctor-app-megamenu></doctor-app-megamenu> -->

        <div class="layout-sidebar" (click)="onMenuClick($event)" [ngClass]="{'layout-sidebar-dark': menuMode !== 'light',
         'layout-sidebar-gradient':  menuMode === 'gradient'}">
            <div class="user-profile">
                <a [routerLink]="'/' + this.slug+'/' + this.edit_url" id="sidebar-profile-button">
                    <span class="sidebar-profile-name">Welcome!</span>
                    <img [src]="(this.avatar_url==null || (this.avatar_url!=null && this.avatar_url.length==0)) ?'./assets/images/default_profile.jpg':this.avatar_url"
                        style="border-radius: 50%;margin-right:auto;margin-left:auto;" class="avatar-image">
                    <span class="sidebar-profile-name">{{name | titlecase}}</span>
                    <br>
                    <span class="sidebar-profile-name">({{currentRoleIDLabel | titlecase}})</span>
                </a>
            </div>
            <div class="sidebar-scroll-content">
                <!-- <doctor-app-inline-profile *ngIf="profileMode=='inline' && !isHorizontal()"></doctor-app-inline-profile> -->
                <doctor-app-menu></doctor-app-menu>
            </div>
        </div>

        <!-- <doctor-app-rightpanel></doctor-app-rightpanel> -->
        <div class="layout-main">
            <doctor-app-breadcrumb></doctor-app-breadcrumb>

            <div class="layout-main-content">
                <router-outlet></router-outlet>
            </div>

            <!-- <doctor-app-footer></doctor-app-footer> -->
        </div>
    </div>

</ng-container>

<ng-container *ngIf="this.isRefreshAvialable()">
    <app-loading class="ui-g-12 text-center" type='LOADING_DATA'></app-loading>
</ng-container>